import { render, staticRenderFns } from "./itemfetch.vue?vue&type=template&id=a6aa9a18&scoped=true&"
import script from "./itemfetch.vue?vue&type=script&lang=tsx&"
export * from "./itemfetch.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6aa9a18",
  null
  
)

export default component.exports